export interface MailMergeResult {
  leadId: string;
  leadName: string;
  leadEmail: string;
  leadPhone: string;
  leadAddress: string;
  leadWebsite: string;
  leadCategory: string;
  leadStatus: string;
  status: 'pending' | 'generating' | 'success' | 'failed';
  subject?: string;
  emailBody?: string;
  callScript?: string;
  error?: string;
  contactName?: string;
  contactPosition?: string;
  emailSource?: string;
}

export type OutputType = 'email' | 'call' | 'both';

export function exportMailMergeToCSV(
  results: Map<string, MailMergeResult>,
  outreachType: string,
  outputType: OutputType
): void {
  const rows = Array.from(results.values());
  if (rows.length === 0) return;

  const headers = [
    'Name', 'Email', 'Email Source', 'Contact Name', 'Contact Position',
    'Phone', 'Address', 'Website', 'Category', 'Lead Status',
    'Outreach Type', 'Email Subject', 'Email Body', 'Call Script',
    'Generation Status', 'Error'
  ];

  const csvRows = rows.map(r => [
    r.leadName,
    r.leadEmail,
    r.emailSource || 'lead',
    r.contactName || '',
    r.contactPosition || '',
    r.leadPhone,
    r.leadAddress,
    r.leadWebsite,
    r.leadCategory,
    r.leadStatus,
    outreachType,
    r.subject || '',
    r.emailBody || '',
    r.callScript || '',
    r.status,
    r.error || ''
  ]);

  const escape = (val: string) => {
    if (val.includes(',') || val.includes('"') || val.includes('\n')) {
      return `"${val.replace(/"/g, '""')}"`;
    }
    return val;
  };

  const csv = [
    headers.map(escape).join(','),
    ...csvRows.map(row => row.map(escape).join(','))
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `mailmerge_${outreachType}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
